import { GetSearchConditionsApi } from "@/features/accounts/shared/services/get-search-conditions-api";
import { GetSearchConditionsGetRequestModel } from "@/features/accounts/shared/services/get-search-conditions-model";

/// 検索条件取得処理
export class GetSearchConditionsService {
  private getSearchConditionsApi = new GetSearchConditionsApi();

  /**
   * 銀行明細更新API実行
   */
  public async getSearchConditions(param: GetSearchConditionsGetRequestModel) {
    return await this.getSearchConditionsApi.getSearchConditions(param);
  }
}
